import { HttpParams } from '@angular/common/http';
import { InputAdapterService } from '@api/services/input-adapter/input-adapter.service';
import { Injectable } from '@angular/core';
import {
  ApiParams,
  ApiParamsAlterate,
  QuotationParamsDTO
} from '@core/modules/api/models';

@Injectable({
  providedIn: 'root'
})
export class InputAdapterCustomService extends InputAdapterService {
  constructor() {
    super();
  }

  postQuotations(
    params: ApiParams<void, QuotationParamsDTO>
  ): ApiParamsAlterate<void> {
    return {
      ...params,
      body: {
        productCode: params.body.productCode,
        loanPurpose: params.body.finality,
        requestedAmount: params.body.amount,
        installment: params.body.installment,
        duration: params.body.duration,
        processType: params.body.processType,
        campaignCode: params.body.campaignCode,
        constraints:
          !!params.body.campaignCode && !!params.body.constraints
            ? { ...params.body.constraints }
            : undefined,
        customers: params.body.communicationsModality && [
          {
            communicationsModality: params.body.communicationsModality
          }
        ]
      }
    };
  }

  getQuotationsBoundaries(
    params: ApiParams<void, void>
  ): ApiParamsAlterate<void> {
    if (
      params.options &&
      params.options.params instanceof HttpParams &&
      !params.options.params.has('campaignCode')
    ) {
      params.options.params = params.options.params.delete('tanMin');
      params.options.params = params.options.params.delete('tanMax');
    }

    return params;
  }

  postPsd2Start(
    params: ApiParams<{ positionId: string }, void>
  ): ApiParamsAlterate<{ positionId: string }> {
    return { ...params, body: {} };
  }
}
